import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import AccordionSectionProps from "@/app/interfaces/props/AccordionSectionProps";
import { useState } from "react";

const AccordionSection = ({
  title,
  children,
  defaultExpanded = false,
  disableGutters,
}: AccordionSectionProps) => {
  const [expanded, setExpanded] = useState<boolean>(defaultExpanded);

  return (
    <Accordion
      elevation={0}
      disableGutters={disableGutters}
      square
      expanded={expanded}
      onChange={(_, isOpen) => setExpanded(isOpen)}
      sx={{
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        "&:before": { display: "none" },
        overflow: "hidden",
        margin: "0 !important",
        "&.Mui-expanded": {
          margin: "0 !important",
        },
      }}
    >
      <AccordionSummary
        expandIcon={
          <Box
            sx={{
              width: 24,
              height: 24,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            {expanded ? (
              <RemoveIcon fontSize="small" />
            ) : (
              <AddIcon fontSize="small" />
            )}
          </Box>
        }
      >
        <Typography variant="subtitle1" fontWeight={600} color="text.secondary">
          {title}
        </Typography>
      </AccordionSummary>

      <AccordionDetails
        sx={{ px: 2, pt: 0, pb: 2, bgcolor: "background.paper" }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionSection;
